import { useMemo, FC } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
} from '@chakra-ui/react';
import { ApiKeyTemplate } from 'types/apiKeyTemplate';
import { CrawlerRegistrationFormFields } from '../../../types/crawlerRegistrationFormFields';

type Props = {
  values: CrawlerRegistrationFormFields;
  handleClose: () => void;
  selectedApiKeyTemplate: ApiKeyTemplate | null;
};

export const CrawlerRegistrationResultModalView: FC<Props> = ({
  values,
  handleClose,
  selectedApiKeyTemplate,
}) => {
  const apiKeyTemplateValue = useMemo(
    () =>
      values.apiKeyTemplateId === '' ? '不要' : selectedApiKeyTemplate?.name,
    [selectedApiKeyTemplate?.name, values.apiKeyTemplateId],
  );

  return (
    <ModalContent maxHeight="90vh">
      <ModalHeader p="40px">クローラーの登録</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>クローラーID</FormLabel>
            <Input
              type="text"
              value={values.id}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>クローラー名</FormLabel>
            <Input
              type="text"
              value={values.name}
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>イメージ名</FormLabel>
            <Input
              type="text"
              value={values.imageName}
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>バージョン</FormLabel>
            <Input
              type="text"
              value={values.version}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>APIキーテンプレート</FormLabel>
            <Input
              type="text"
              value={apiKeyTemplateValue}
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
        </Stack>
        <Text align="center" fontWeight="bold" mt="60px">
          登録が完了しました
        </Text>
      </ModalBody>
      <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          variant="outline"
          onClick={handleClose}
        >
          閉じる
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};
